import { v4 as uuid } from 'uuid';
import { CatSkeleton } from 'components/blocks-components';
import { EquipmentInfoLoader } from './equipment-Info-loader';
import { EquipmentDescriptionLoader } from './equipment-description-loader';
import { ServiceInsightHeading } from '../service-insight-heading';
import cx from 'classnames';
import styles from './service-insight-loader.module.scss';

export const ServiceInsightSkeletonLoader = () => {
  const lgCardsCount = 4;
  return (
    <section className={'my-3 m-blg-0'}>
      <div className="d-none d-blg-block">
        <ServiceInsightHeading isViewAllBtnEnable={false} />
      </div>
      <div className="d-none d-blg-block">
        {Array.from({ length: lgCardsCount }).map(() => {
          return (
            <div className={'p-0 m-0 row'} key={uuid()}>
              <div
                className={`px-lg-0 ${styles['service-insight-desktop-loader']}`}
              >
                <div
                  className={`${styles['service-insight-desktop-loader__wrapper']} d-flex flex-md-column-reverse flex-lg-row row-gap-md-2 row-gap-lg-0 align-items-lg-center column-gap-lg-3 mr-lg-3 my-lg-3 py-md-0 ps-lg-0`}
                >
                  <div className={'w-25'}>
                    <EquipmentInfoLoader />
                  </div>
                  <EquipmentDescriptionLoader isDesktop={true} />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className={'p-0 m-0 cat-u-padding-top-lg d-blg-none'}>
        <CatSkeleton
          width="155px"
          className={cx('d-block', styles['service-insight-title'])}
        />

        <div
          className={`${styles['service-insight-loader']} ps-lg-0 mt-2 w-100`}
        >
          <div
            className={`${styles['service-insight-loader__wrapper']} d-flex flex-md-column-reverse flex-lg-row row-gap-md-2 row-gap-lg-0 align-items-lg-center column-gap-lg-3 mr-lg-3 my-lg-3 py-md-0 ps-lg-0`}
          >
            <div className={'col-12 col-md-6'}>
              <EquipmentInfoLoader />
            </div>
            <EquipmentDescriptionLoader isDesktop={false} />
          </div>
        </div>
      </div>
    </section>
  );
};
